import deliveryIcon from '../assets/delivery.svg'
import groceriesIcon from '../assets/groceries.svg'
import restaurantIcon from '../assets/restaurants.svg'

interface WhyGlovoContentBox {
  titleKey: string
  descriptionKey: string
  highlightKey: string
  imageId: string
}

export const whyGlovoContent: WhyGlovoContentBox[] = [
  {
    titleKey: 'why-glovo.restaurants.title',
    descriptionKey: 'why-glovo.restaurants.description',
    highlightKey: 'why-glovo.restaurants.highlight',
    imageId: restaurantIcon,
  },
  {
    titleKey: 'why-glovo.delivery.title',
    descriptionKey: 'why-glovo.delivery.description',
    highlightKey: 'why-glovo.delivery.highlight',
    imageId: deliveryIcon,
  },
  {
    titleKey: 'why-glovo.groceries.title',
    descriptionKey: 'why-glovo.groceries.description',
    highlightKey: 'why-glovo.groceries.highlight',
    imageId: groceriesIcon,
  },
]
